import { render, staticRenderFns } from "./DisplayLayouts.vue?vue&type=template&id=6bf02984"
import script from "./DisplayLayouts.vue?vue&type=script&lang=js"
export * from "./DisplayLayouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports